import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  AfterViewChecked,
  ViewChild,
  OnDestroy
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { CampoSolicitud } from '../../core/model/campo-solicitud';
import { Cliente } from '../../core/model/cliente';
import { ComboNgSelect } from '../../core/model/combos';
import { DepartamentoSerie } from '../../core/model/departamento-serie';
import {
  ContadorContenidos,
  DataReturnsSelected
} from '../../core/model/detalle-solicitud';
import { FiltroDevolucion } from '../../core/model/filtro-devolucion';
import {
  FileData
} from '../../core/model/massive-load-result';
import { SolicitudPrestamo } from '../../core/model/solicitud-prestamo';
import { SpecialFormValidators } from '../../core/model/specialFormValidators';
import { Template } from '../../core/model/template';
import { SelectValue } from '../../core/model/template-field';
import { UnidadSolicitud } from '../../core/model/unidad-solicitud';
import { UsuarioCliente } from '../../core/model/usuario-cliente';
import { AuthenticationService } from '../../core/services/authentication.service';
import { ClientesService } from '../../core/services/clientes.service';
import { DepartamentosSeriesService } from '../../core/services/departamentos-series.service';
import { SeriesService } from '../../core/services/series.service';
import { SessionService } from '../../core/services/session.service';
import { TemplatesService } from '../../core/services/templates.service';
import { UsersService } from '../../core/services/users.service';
import { UtilitiesService } from '../../core/services/Utility/utilities.service';
import { TemplateField } from './../../core/model/template-field';
import { RangoSimple } from '../../core/model/Rangos';
import { CamposPlantillaComponent } from './campos-plantilla/campos-plantilla.component';

@Component({
  selector: 'app-formulario-plantilla',
  templateUrl: './formulario-plantilla.component.html',
  styleUrls: ['./formulario-plantilla.component.css']
})
export class FormularioPlantillaComponent
  implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChild('camposss') camposPlantillaComponent: CamposPlantillaComponent;

  @Input() tipoSolicitud: string;
  @Input() fixed: boolean;
  @Input() cargaMasiva: boolean;
  @Input() hasShowClientUsers = true;
  @Input() busquedaInventario = false;
  @Input() maxContenidos: number;
  @Input()
  set unidadAEditar(unidad: UnidadSolicitud) {
    this._unidadAEditar = unidad;
    this.editing = unidad !== undefined;
    if (unidad) {
      this.campos.forEach(campo => {
        campo.value = unidad.campos.find(c => c.nombre === campo.nombre).valor;
      });
    }
  }
  get unidadAEditar(): UnidadSolicitud {
    return this._unidadAEditar;
  }
  _isPrestamoInventario: boolean;

  @Input() set isPrestamoInventario(isInventario: boolean) {
    this._isPrestamoInventario = isInventario;
    if (!this._isPrestamoInventario) {
      this.hasToSelectUser = false;
    }
  }

  @Input() hasAddMoreUnits: boolean;
  @Output() hasAddMoreUnitsChange = new EventEmitter<boolean>();

  @Input() hasFindFields = true;
  @Input() addIdContenido = false;

  @Input() clientIdSelected = 0;
  @Input() isDevolucionByData = false;
  @Input() showDocumentacionDevolucion = false;
  @Input() set dataSelected(data: DataReturnsSelected) {
    this.hasHideMainData = data.needDataToShowData;
    if (data.serieId) {
      this.cliente = data.clientSelected;
      this.usuarioSeleccionado = data.userSelected;
      this.serie = data.serieId;
      this.getCampos();
    } else {
      this.campos = [];
      this.camposSencillos = [];
      this.camposRangoNombres = [];
    }
  }
  @Output() nuevaUnidad = new EventEmitter();
  @Output() valoresEstablecidos = new EventEmitter();
  @Output() camposEstablecidos = new EventEmitter();
  @Output() serieEstablecida = new EventEmitter();
  @Output() clienteUsuarioEstablecido = new EventEmitter();
  @Output() contadorPrestamos = new EventEmitter<ContadorContenidos>();
  @Output() filtroDevoluciones = new EventEmitter<FiltroDevolucion>();
  @Output() newFileUploaded = new EventEmitter<FileData>();
  @Output() unidadEditada = new EventEmitter<UnidadSolicitud>();
  @Output() cargandoDevoluciones = new EventEmitter<boolean>();
  @Output() hasFieldsRangeInSearch = new EventEmitter<boolean>();
  @Output() documentationFiles = new EventEmitter<FileData[]>();
  @Output() isFormGroupValid = new EventEmitter<boolean>();
  @Output() resetUnitDevoluciones = new EventEmitter<boolean>();

  documentsFiles: FileData[] = [];

  private _unidadAEditar: UnidadSolicitud;
  editing = false;

  public campos: TemplateField[] = undefined;
  public camposSencillos: TemplateField[] = [];
  camposRango = new Map<
    string,
    { desde: TemplateField; hasta: TemplateField }
  >();
  camposRangoNombres: string[] = [];

  camposRangoSimple = new Map<string, RangoSimple>();

  solicitud: SolicitudPrestamo;
  unidades: any[];
  formGroup: FormGroup;
  departamentosSeries = new Map<number, any>();
  serieValida = false;
  cliente = undefined;
  usuarioSeleccionado = undefined;
  departamento = undefined;
  serie: number = undefined;
  departamentos: number[] = [];
  clientes: Cliente[] = [];
  usuarios: UsuarioCliente[] = [];
  showError = false;
  loading = false;
  isDocoutUser = false;
  isSupervisor = false;
  isAdmin = false;
  fechaDesde: Date;
  fechaHasta: Date;
  public bsConfig: BsDatepickerConfig;
  selectValueMap = new Map<number, SelectValue[]>();
  titulo = 'Seleccione un valor';
  templateId: number;
  hasResetMultivalues = false;

  hasToSelectUser = false;
  azInventoryLevel = false;

  departamentosCombo: ComboNgSelect[] = undefined;
  seriesCombo: ComboNgSelect[] = undefined;

  showDocumentacionSolicitud = false;

  rangeSearchMode: string;

  isFormValid = false;

  hasHideMainData: boolean;

  constructor(
    private templatesService: TemplatesService,
    private departamentosSeriesService: DepartamentosSeriesService,
    private localeService: BsLocaleService,
    private clientesService: ClientesService,
    private authService: AuthenticationService,
    private usersService: UsersService,
    private toastrService: ToastrService,
    private utilsService: UtilitiesService,
    private seriesService: SeriesService,
    private sessionService: SessionService
  ) {
    this.localeService.use('es');
  }

  ngOnInit() {
    this.cliente = undefined;
    this.usuarioSeleccionado = undefined;
    this.usuarios = [];
    this.departamento = undefined;
    this.serie = undefined;
    this.showError = false;
    this.campos = [];
    this.camposSencillos = [];
    if (this.departamento && this.serie) {
      this.getCampos();
    }
    this.clientesService.getAllClientes().subscribe((clientes: Cliente[]) => {
      this.clientes = clientes.sort(function (a, b) {
        if (a.NOMBRE < b.NOMBRE) { return -1; }
        if (a.NOMBRE > b.NOMBRE) { return 1; }
        return 0;
      });
      if (
        this._isPrestamoInventario &&
        this.clientIdSelected != 0 &&
        this.clientes.some(x => x.ID == this.clientIdSelected)
      ) {
        this.cliente = this.clientIdSelected;
        this.hasToSelectUser = true;
        this.hasShowClientUsers = true;
        this.procesarClienteSeleccionado();
      }
      if (this.clientes.length == 1 && this.isServiceToAttachFiles()) {
        this.showDocumentacionSolicitud = this.clientes[0].DocumentacionSolicitudes;
      }
    });

    this.authService.isDocOutUser().then((isDocUser: boolean) => {
      this.isDocoutUser = isDocUser;
      if (!this.isDocoutUser) {
        this.getDepartamentosSeries();
        this.manageUserSupervisor();
      }
    });

    this.bsConfig = this.utilsService.getDatepickerConfig();
    this.fechaDesde = undefined;
    this.fechaHasta = undefined;
    this.rangeSearchMode = this.authService.getBusquedaRangoSimple();
  }

  private isServiceToAttachFiles() {
    return (
      this.tipoSolicitud === 'prestamos' ||
      this.tipoSolicitud === 'recogida' ||
      this.tipoSolicitud === 'entrega'
    );
  }

  ngAfterViewChecked() {
    // if (
    //   this.isDevolucionByData &&
    //   this.formGroup &&
    //   this.isFormValid != this.formGroup.valid
    // ) {
    //     this.isFormValid = this.formGroup.valid;
    //     if (this.isFormValid) {
    //       this.addUnidad();
    //     } else {
    //       this.resetUnitDevoluciones.emit(true);
    //     }
    //     this.isFormGroupValid.emit(this.isFormValid);
    //   }
  }

  manageUserSupervisor() {
    this.usuarioSeleccionado = this.authService.getUserId();
    this.isSupervisor = this.authService.isSupervisorUser();
    this.isAdmin = this.authService.isAdminUser();
    if (this.isSupervisor || this.isAdmin) {
      this.cliente = this.sessionService.getClientId();
      this.getUsersByClient(this.cliente);
    }
  }

  getDepartamentosSeries() {
    this.departamentosSeries.clear();
    this.departamentos = [];

    const clienteId = this.isDocoutUser
      ? this.cliente
      : this.sessionService.getClientId();

    this.departamentosSeriesService
      .getDepartamentosSeriesByClient(clienteId, this.usuarioSeleccionado)
      .pipe(first())
      .subscribe((departamentosSeries: DepartamentoSerie[]) => {
        departamentosSeries.forEach((departamentoSerie: DepartamentoSerie) => {
          if (!this.departamentosSeries.has(departamentoSerie.idDepartamento)) {
            this.departamentosSeries.set(departamentoSerie.idDepartamento, {
              nombre: departamentoSerie.nombreDepartamento,
              series: []
            });
            this.departamentos.push(departamentoSerie.idDepartamento);
          }
          if (
            this.departamentosSeries
              .get(departamentoSerie.idDepartamento)
              .series.filter(
                serie => serie.idSerie === departamentoSerie.idSerie
              ).length === 0
          ) {
            this.departamentosSeries
              .get(departamentoSerie.idDepartamento)
              .series.push({
                idSerie: departamentoSerie.idSerie,
                nombreSerie: departamentoSerie.nombreSerie
              });
          }
        });

        this.departamentosCombo = this.getDepartamentosCombo(
          this.departamentosSeries
        );
        if (this.departamentosSeries.size === 1) {
          this.departamento = this.departamentosSeries.keys().next().value;
          this.seriesCombo = this.getSeriesCombo(
            this.departamentosSeries.get(this.departamento).series
          );
          if (
            this.departamentosSeries.get(this.departamento).series.length === 1
          ) {
            this.serie = this.departamentosSeries.get(
              this.departamento
            ).series[0].idSerie;
            this.getCampos();
          }
        }
      });
  }
  private getDepartamentosCombo(
    departamentosSeries: Map<number, any>
  ): ComboNgSelect[] {
    const comboDepartamentos = [];
    departamentosSeries.forEach((value: any, key: number) => {
      const departamentoCombo = new ComboNgSelect();
      departamentoCombo.ID = key;
      departamentoCombo.NOMBRE = value.nombre;
      comboDepartamentos.push(departamentoCombo);
      if (this.departamento == key) {
        this.seriesCombo = this.getSeriesCombo(value.series);
      }
    });
    this.departamentosCombo = [...comboDepartamentos];
    return this.departamentosCombo.sort(function (a, b) {
      return a == b ? 0 : b > a ? -1 : 1;
    });
  }
  private getSeriesCombo(series: any[]): ComboNgSelect[] {
    const comboSeries = [];
    series.map(serie => {
      const serieCombo = new ComboNgSelect();
      serieCombo.ID = serie.idSerie;
      serieCombo.NOMBRE = serie.nombreSerie;
      comboSeries.push(serieCombo);
    });
    this.seriesCombo = [...comboSeries];
    return this.seriesCombo;
  }

  getSeriesforSelectedDepartment() {
    if (
      this.departamentosSeries &&
      this.departamentosSeries.get(+this.departamento)
    ) {
      const auxComboSeries = this.departamentosSeries
        .get(+this.departamento)
        .series.map(serie => {
          const serieCombo = new ComboNgSelect();
          serieCombo.ID = serie.idSerie;
          serieCombo.NOMBRE = serie.nombreSerie;
          return serieCombo;
        });
      this.seriesCombo = [...auxComboSeries];
      if (this.seriesCombo.length == 1) {
        this.serie = this.seriesCombo[0].ID;
        this.getCampos();
      }
    }
  }

  getCampos() {
    this.formGroup = undefined;
    if (!!this.serie) {
      this.seriesService
        .getSerieById(this.serie)
        .pipe(first())
        .subscribe(
          result => (this.azInventoryLevel = result.inventoryLevelId === 2),
          error => (this.azInventoryLevel = false)
        );
      this.campos = [];
      this.camposSencillos = [];
      if (!this.hasHideMainData) {
        this.serieEstablecida.emit(this.serie);
      }
      if (this.hasFindFields) {
        this.loading = true;
        this.templatesService
          .getTemplateFields(this.tipoSolicitud, this.serie)
          .pipe(first())
          .subscribe(
            (plantilla: Template) => {
              if (plantilla === null) {
                this.toastrService.warning(
                  'La serie seleccionada no puede ser usada para este tipo de solicitud.',
                  'Serie no válida'
                );
                this.serieValida = false;
                this.loading = false;
                return;
              }
              this.templateId = plantilla.idPlantilla;
              this.serieValida = true;
              this.campos = plantilla.campos;
              this.camposSencillos = this.busquedaInventario
                ? this.campos.filter(
                    c => !c.rango && c.subtipo !== 'RANGO_SIMPLE'
                  )
                : this.campos;
              const group = {};
              this.camposRango.clear();
              this.camposRangoNombres = [];
              this.campos.forEach((campo: TemplateField) => {
                this.proccessFieldsRange(campo);
                if (campo.VALOR_PORDEFECTO !== null && campo.VALOR_PORDEFECTO !== undefined) {
                  campo.value = campo.VALOR_PORDEFECTO;
                }
                const control = new FormControl(campo.value);
                const validators = [];
                if (campo.obligatorio && !this.busquedaInventario) {
                  validators.push(Validators.required);
                }
                if (campo.subtipo && campo.subtipo.startsWith('VALIDACION')) {
                  const validator = this.getValidationError(campo.subtipo);
                  if (validator) {
                    validators.push(validator);
                  }
                }
                if (campo.max) {
                  validators.push(Validators.maxLength(campo.max));
                }
                if (campo.min) {
                  validators.push(Validators.minLength(campo.min));
                }
                control.setValidators(validators);
                group[campo.nombre] = control;
              });
              if (this.addIdContenido)
                group['idcontenido'] = new FormControl('');
              this.formGroup = new FormGroup(group);
              this.isFormValid = this.formGroup.valid;
              this.isFormGroupValid.emit(this.isFormValid);
              this.loading = false;
              this.camposEstablecidos.emit(this.campos);
              if (
                this.tipoSolicitud === 'devolucion' &&
                !this.hasHideMainData
              ) {
                this.buscarPrestamos();
              }
            },
            error => {
              console.log('Error en login: ' + error);
              this.loading = false;
              this.camposEstablecidos.emit([]);
            }
          );
      }
    } else {
      this.serieEstablecida.emit(null);
    }
  }
  private proccessFieldsRange(campo: TemplateField) {
    if (campo.rango && this.busquedaInventario) {
      const aux = this.camposRango.get(campo.descripcion) || {
        desde: undefined,
        hasta: undefined
      };
      if (campo.rango === 1) {
        aux.desde = campo;
      }
      if (campo.rango === 2) {
        aux.hasta = campo;
      }
      this.camposRango.set(campo.descripcion, aux);

      if (this.camposRangoNombres.indexOf(campo.descripcion) < 0) {
        this.camposRangoNombres.push(campo.descripcion);
      }
    }
    if (campo.subtipo === 'RANGO_SIMPLE') {
      const aux = CamposPlantillaComponent.createRangoSimple(campo);
      this.camposRangoSimple.set(campo.descripcion, aux);
    }
  }

  getValidationError(subtipo: string): any {
    const typeValidation = subtipo.substr('VALIDACION.'.length);
    if (typeValidation === 'NIF') {
      return SpecialFormValidators.validateNIF;
    }
    if (typeValidation === 'CIF') {
      return SpecialFormValidators.validateCIF;
    }
    if (typeValidation == 'CUPS') {
      return SpecialFormValidators.validateCUPS;
    }
    if (typeValidation == 'IBAN') {
      return SpecialFormValidators.validateIBAN;
    }
    return null;
  }

  addUnidad() {
    if (this.formGroup.valid) {
      this.showError = false;
      const unidad = new UnidadSolicitud();
      this.campos.forEach((campo: TemplateField) => {
        const campoUnidad = new CampoSolicitud();
        campoUnidad.id = campo.id;
        campoUnidad.nombre = campo.nombre;
        campoUnidad.descripcion = campo.descripcion;
        if (campo.subtipo === 'RANGO_SIMPLE') {
          campoUnidad.valor = this.getValueCampoRangoSimple(campo.descripcion);
        } else if (
          campo.tipo === 'ARRAY' &&
          campo.subtipo !== 'BIGDATA' &&
          campo.multivalue
        ) {
          campoUnidad.valor =
            !campo.value || [].concat(campo.value).length === 0
              ? []
              : [].concat(campo.value);
        } else if (
          campo.tipo === 'ARRAY' &&
          campo.subtipo !== 'BIGDATA' &&
          this.busquedaInventario
        ) {
          const value = campo.defaultValues.find(
            defaultValue => defaultValue.id == this.formGroup.controls[campo.nombre].value
          );
          campoUnidad.valor = !!value ? value.valor : null;
        } else {
          campoUnidad.valor = campo.value;
        }
        campoUnidad.multivalue = campo.multivalue;
        unidad.campos.push(campoUnidad);
      });

      this.notificarCamposDeRangoConValor();

      this.valoresEstablecidos.emit(unidad);
      if (
        !this.busquedaInventario &&
        this.maxContenidos != 1 /*&&
        !this.isDevolucionByData*/
      ) {
        this.serieValida = false;
        if (this.camposPlantillaComponent) {
          this.camposPlantillaComponent.limpiar();
        }
      }
    } else {
      this.showError = true;
      if (this.camposPlantillaComponent) {
        this.camposPlantillaComponent.marcarCamposErroneos();
      }
    }
  }
  private getValueCampoRangoSimple(name) {
    const campoRangoSimple: RangoSimple = this.camposRangoSimple.get(name);
    if (!!campoRangoSimple.desde && !!campoRangoSimple.desde.value) {
      const value = campoRangoSimple.type === 'DATE'
        ? campoRangoSimple.desde.value.toLocaleString()
        : campoRangoSimple.desde.value;
      return value + 'gt';
    }
    if (!!campoRangoSimple.hasta && !!campoRangoSimple.hasta.value) {
      const value = campoRangoSimple.type === 'DATE'
        ? campoRangoSimple.hasta.value.toLocaleString()
        : campoRangoSimple.hasta.value;
      return value + 'lt';
    }
    if (!!campoRangoSimple.igual && !!campoRangoSimple.igual.value) {
      const value = campoRangoSimple.type === 'DATE'
        ? campoRangoSimple.igual.value.toLocaleString()
        : campoRangoSimple.igual.value;
      return value + 'eq';
    }
    if (!!campoRangoSimple.entre) {
      const valueDesde = campoRangoSimple.type === 'DATE'
        ? campoRangoSimple.entre.desde.value.toLocaleString()
        : campoRangoSimple.entre.desde.value;
      const valueHasta = campoRangoSimple.type === 'DATE'
        ? campoRangoSimple.entre.hasta.value.toLocaleString()
        : campoRangoSimple.entre.hasta.value;
      return (
        valueDesde +
        '#.o' +
        valueHasta +
        'en'
      );
    }
    return undefined;
  }
  private notificarCamposDeRangoConValor() {
    let hasCamposRango = false;

    this.camposRango.forEach(
      (value: { desde: TemplateField; hasta: TemplateField }, key: string) => {
        if (!!value.desde.value || !!value.hasta.value) {
          hasCamposRango = true;
          return;
        }
      }
    );

    this.hasFieldsRangeInSearch.emit(hasCamposRango);
  }

  procesarClienteSeleccionado() {
    this.departamento = undefined;
    this.serie = undefined;
    this.serieEstablecida.emit(undefined);
    this.usuarioSeleccionado = undefined;
    this.campos = [];
    this.camposSencillos = [];
    if (!this.cliente) {
      this.usuarios = [];
      this.departamentosSeries.clear();
      this.departamentos = [];
      this.showDocumentacionSolicitud = false;
    } else if (this.isServiceToAttachFiles()) {
      this.showDocumentacionSolicitud = this.clientes.find(
        cli => cli.ID == this.cliente
      ).DocumentacionSolicitudes;
    }

    if (this.cliente) {
      if (this.hasShowClientUsers) {
        this.getUsersByClient(this.cliente);
      } else {
        this.getDepartamentosSeries();
        this.clienteUsuarioEstablecido.emit({ cliente: this.cliente });
      }
    }
  }

  private getUsersByClient(client: number) {
    this.usersService
      .getUsersByClient(client)
      .subscribe((users: UsuarioCliente[]) => {
        if (this.isSupervisor && this.tipoSolicitud !== 'devolucion') {
          this.usuarioSeleccionado = this.authService.getUserId();
        }
        this.usuarios = users;
      });
  }

  procesarUsuarioSeleccionado() {
    this.departamento = undefined;
    this.serie = undefined;
    this.serieEstablecida.emit(undefined);
    this.campos = [];
    this.camposSencillos = [];
    this.departamentosSeries.clear();
    this.departamentos = [];
    if (!this.usuarioSeleccionado) {
      if (this.isSupervisor && this.tipoSolicitud === 'devolucion') {
        this.getDepartamentosSeries();
      }
    }
    if (this.usuarioSeleccionado) {
      this.getDepartamentosSeries();
    }
    this.clienteUsuarioEstablecido.emit({
      cliente: this.cliente,
      usuario: this.usuarioSeleccionado
    });
  }

  buscarPrestamos() {
    this.loading = true;
    this.contadorPrestamos.emit(null);
    this.cargandoDevoluciones.emit(true);
    if (this.fechaDesde) {
      this.fechaDesde.setHours(0, 0, 0, 0);
    }
    if (this.fechaHasta) {
      this.fechaHasta.setHours(23, 59, 59, 999);
    }
    const filtro = new FiltroDevolucion();
    filtro.FECHA_DESDE = this.fechaDesde;
    filtro.FECHA_HASTA = this.fechaHasta;
    filtro.ID_SOLICITANTE =
      this.usuarioSeleccionado == undefined ? null : this.usuarioSeleccionado;

    this.filtroDevoluciones.emit(filtro);
    this.seriesService
      .getCountPrestamosBySerieId(this.serie, filtro)
      .pipe(first())
      .subscribe(
        (countContenidos: ContadorContenidos) => {
          this.loading = false;
          this.contadorPrestamos.emit(countContenidos);
          this.cargandoDevoluciones.emit(false);
        },
        error => {
          this.loading = false;
          this.cargandoDevoluciones.emit(false);
        }
      );
  }

  ngOnDestroy() {
    if (this.camposPlantillaComponent) {
      this.camposPlantillaComponent.ngOnDestroy();
    }
    this.showDocumentacionSolicitud = false;
  }
}
